import { getInsuranceType } from "../../auth/api"
import { getMonthlyPayment } from "../../../common/utils/mathHelpers"

export function getInsurancePrice(insurance, totalAmount, settings) {
    if (['A', 'B', 'C'].includes(insurance)) {

        let priceKey = `INSURANCE_${insurance}_PRICE_VALUE`
        let uinitKey = `INSURANCE_${insurance}_PRICE_UNIT`

        const price = parseFloat(settings[priceKey])
        const unit = settings[uinitKey]
        
        if (unit === 'EUR') {
            return price
        }
        if (unit === 'percent') {
            return (price / 100.0 * totalAmount)
        }
    }
    return 0
}

export function getInterestDiscount(insuranceType, settings) {
    if (['A', 'B', 'C'].includes(insuranceType)) {
        let key = `INSURANCE_${insuranceType}_INTEREST_DISCOUNT`

        return parseFloat(settings[key]) / 100.0
    }

    return 0
}

export function getInterestValue(months, interestRange) {
    if (!Array.isArray(interestRange)) {
        return null;
    }

    const range = interestRange.find(
        interest => months > interest.termMonthsMin && months <= interest.termMonthsMax
    );

    if (!range) {
        return null;
    }

    const parsedInterest = parseFloat(range.loanInterest);
    return Number.isNaN(parsedInterest) ? null : parsedInterest;
}

export function getLoanCreationAttemptParams(form, monthsNum, amountVal, settings, interestRange) {
    let insuranceType = getInsuranceType(form)

    const months = parseInt(monthsNum, 10)
    let interest = getInterestValue(months, interestRange)
    if (interest === null) {
        throw new Error('Loan interest could not be determined');
    }

    let discount = getInterestDiscount(insuranceType, settings)

    if (discount) {
        interest = interest - discount
    }
  
    const amount = parseFloat(amountVal);
    let payment = getMonthlyPayment(amount, months, interest);
    const insuranceAmount = getInsurancePrice(insuranceType, amount, settings);

    payment = payment + insuranceAmount

    const params = {
        payment,
        interest,
        insuranceAmount,
        packageType: insuranceType,
        interestDiscount: discount,
    }

    return params
}



// WEBPACK FOOTER //
// ./src/features/onboarding/containers/helpers.js